<div class="mt-3 flex">
  <span class="tk-c-gray mr-1">{{'handover.transferring-person' | translate}}</span>
  <span class="font-bold">{{model?.transferringPerson}}</span>
</div>
<div class="mt-6 flex flex-col items-center w-1/2 tk-border-gray-2 rounded-xl">
  <img *ngIf="model?.driverSignatureUrl" class="w-40 mt-2" [src]="model!.driverSignatureUrl | secureImage | async">
  <div class="flex my-3">
    <span class="tk-c-gray mr-1">{{'handover.driver-signature' | translate}}</span>
    <span class="font-bold">{{model?.driverFullName}}</span>
  </div>
</div>
